import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

const PricingConfig = () => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          WhatsApp Pricing Configuration
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Configure Meta cost and margin for different message categories
        </Typography>
        {/* Add pricing configuration component here */}
      </CardContent>
    </Card>
  );
};

export default PricingConfig;
